/**
 * Client-entry side effect: resolve — and thereby persist — the embed context
 * before any app module evaluates. The popup signals are transient: the
 * checkout tracking session overwrites `window.name` at import time, which
 * would erase the `bd-login-<id>` / `bd-payment-<id>` window name before the
 * popup pages could read it. Import this first (before `@/App`) in `src/index.js`.
 */

import { getEmbedContext } from '@/helpers/embed';

getEmbedContext();
